/* RESPONSIBLE TEAM: team-proactive-support */
import BaseStat from './base-stat';
import { attr } from '@ember-data/model';

export default BaseStat.extend({
  answers: attr(),
  questions: attr(),
});
